import { render } from "./SectorDetail.vue?vue&type=template&id=17670373"
import script from "./SectorDetail.vue?vue&type=script&lang=js"
export * from "./SectorDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__